(function () {
    'use strict';

    angular
        .module('recomControllers')
        .controller('GovernanceProcessListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'fiscalYears', 'governanceProcess'];

    function Controller($scope, $state, topBarService, businessUnit, fiscalYears, governanceProcess) {
        topBarService.setTitleAndIcon('Governance Process Management', 'fa fa-road');

        $scope.businessUnit = businessUnit;
        $scope.fiscalYears = fiscalYears;
        $scope.govProcessList = governanceProcess ? [governanceProcess] : [];

        $scope.goHome = function () {
            $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
        };

        $scope.goToGovernanceProcess = function (govProcess) {
            $state.go('recom.editGovernanceProcess', {
                BusinessUnitCode: govProcess.RecomBusinessUnit.Code,
                GovernanceProcessID: govProcess.GovernanceProcessID
            });
        };

        $scope.goToAddGovernanceProcess = function () {
            $state.go('recom.addGovernanceProcess', {
                BusinessUnitCode: $scope.businessUnit.Code
            });
        };
    }
})();   